import React from 'react'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'

const ProjectNotFound = () => (
  <section>
    <header>
      <PageTitle>
        Project not found!
      </PageTitle>
    </header>
    <br/>
    <BackButton/>
  </section>
)

export default ProjectNotFound



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectNotFound.jsx